import { useState, useCallback } from 'react';
import type { Post } from '../types';

// Using the specified video for reliable playback
const VIDEO_SOURCES = [
  'https://r2.iphimedeia.com/mypressalert/videoplayback.mp4',
  'https://r2.iphimedeia.com/mypressalert/videoplayback.mp4',
  'https://r2.iphimedeia.com/mypressalert/videoplayback.mp4'
];

const MOCK_POSTS: Post[] = [
  {
    id: 'post_1',
    videoUrl: VIDEO_SOURCES[0],
    caption: 'Trump jumps right to the blame game over DC midair collision. Former president Donald Trump wastes no time pointing fingers after a mid-air collision between two aircraft in Washington DC. #politics #breakingnews #trump #aviation',
    username: 'cnn',
    comments: 0,
    shares: 0,
    hashtags: ['politics', 'breakingnews', 'trump', 'aviation'],
    userAvatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/CNN_International_logo.svg/2048px-CNN_International_logo.svg.png',
  },
  {
    id: 'post_2',
    videoUrl: VIDEO_SOURCES[0],
    caption: 'New green energy policies proposed to combat climate change. The administration has outlined ambitious plans that could transform how America generates electricity. #climate #energy #policy #greenenergy',
    username: 'bbcnews',
    comments: 0,
    shares: 0,
    hashtags: ['climate', 'energy', 'policy', 'greenenergy'],
    userAvatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/BBC_Logo_2021.svg/512px-BBC_Logo_2021.svg.png',
  },
  {
    id: 'post_3',
    videoUrl: VIDEO_SOURCES[0],
    caption: 'Tech giants face new scrutiny over data privacy practices. Several major technology companies are under investigation for potential violations of user privacy regulations. #tech #privacy #data #regulation',
    username: 'reuters',
    comments: 0,
    shares: 0,
    hashtags: ['tech', 'privacy', 'data', 'regulation'],
    userAvatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Reuters_logo.svg/512px-Reuters_logo.svg.png',
  },
];

const PAGE_SIZE = 1;

export function usePosts() {
  const [posts, setPosts] = useState<Post[]>([MOCK_POSTS[0]]);
  const [currentPage, setCurrentPage] = useState(0);

  const loadNextPost = useCallback(() => {
    const nextPage = currentPage + 1;
    const startIndex = nextPage * PAGE_SIZE % MOCK_POSTS.length;
    
    // Create a new post with a unique ID by appending a timestamp
    const nextPost = {
      ...MOCK_POSTS[startIndex],
      id: `post_${startIndex}_${Date.now()}`
    };
    
    setPosts(prev => [...prev, nextPost]);
    setCurrentPage(nextPage);
  }, [currentPage]);

  const loadPreviousPost = useCallback(() => {
    const prevPage = currentPage - 1;
    if (prevPage >= 0) {
      const startIndex = prevPage * PAGE_SIZE % MOCK_POSTS.length;
      
      // Create a new post with a unique ID by appending a timestamp
      const prevPost = {
        ...MOCK_POSTS[startIndex],
        id: `post_${startIndex}_${Date.now()}`
      };
      
      setPosts(prev => [prevPost, ...prev]);
      setCurrentPage(prevPage);
    }
  }, [currentPage]);

  return {
    posts,
    loadNextPost,
    loadPreviousPost,
    hasMore: true, // Always allow loading more since we're cycling through posts
    hasPrevious: currentPage > 0
  };
}